import { Icon } from '@chakra-ui/react';
const BatteryIcon = () => {
    return (
        <>
            <Icon 
                width="18" 
                height="22" 
                viewBox="0 0 12 20" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M10.67 2H9V0H3V2H1.33C0.977262 2 0.638971 2.14012 0.389548 2.38955C0.140124 2.63897 0 2.97726 0 3.33V18.67C0 19.4 0.6 20 1.33 20H10.67C11.0227 20 11.361 19.8599 11.6105 19.6105C11.8599 19.361 12 19.0227 12 18.67V3.33C12 2.6 11.4 2 10.67 2Z"
                    fill="#CCF0F7"
                />
            </Icon>
        </>
    )
}
export default BatteryIcon;
